module.exports = __webpack_public_path__ + "static/plant-e62e7305a38167ce35e000156e8cbda8.jpg";